import { Component, OnInit } from '@angular/core';
import { Po } from '../po';
import { Email } from '../../user/email';
import { UserService } from '../../user/user.service';
import { Poitem } from '../poitem';
import { PoService } from '../po.service';
import { VendorService } from '../../vendor/vendor.service';
import { PaymenttermService } from '../../paymentTerms/paymentterm.service';
import { DepartmentService } from '../../department/department.service';
import { ItemService } from '../../item/item.service';
import { EntityService } from '../../entity/entity.service';
import { WarehouseService } from '../../warehouse/warehouse.service';
import { CostcenterService } from '../../costcenter/costcenter.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { FileUploadModule } from "ng2-file-upload";  
import { DatepickerOptions } from 'ng2-datepicker';
import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../environments/environment';
const baseUrl = environment.baseUrl;
const webUrL = environment.webUrL;
const URL = baseUrl+'/api/upload';
@Component({
  selector: 'app-create-po',
  templateUrl: './create-po.component.html',
  styleUrls: ['./create-po.component.css']
})
export class CreatePOComponent implements OnInit {

public uploader: FileUploader;
	authHeader: Array<Headers> = [];
		authToken = '';
  public dateOptions: DatepickerOptions = {
  //this.dateOptions = {
    minYear: 1999,
    maxYear: 2030,
    displayFormat: 'MMM D[,] YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
   // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  
  public dateOptionsDeliverydate: DatepickerOptions = {
  //this.dateOptions = {
    minYear: 1999,
    maxYear: 2030,
    displayFormat: 'MMM D[,] YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
   // minDate: new Date(Date.now()), // Minimal selectable date
   // maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
   // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker1', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  

  po = new Po();
  purchase_order = new Po();
  TemplateData: string ='';
  emaildata = new Email();

	podata : any = {}
	submitted = false;
	vendors: any[];
	selectedvendor : any ={};
	department: any [];
    requester: any [];
	deleteditem : any [];
	deletedaddtionalitem : any [];
	costcenterlist: any [];
	warehouselist: any [];
	currencylist: any [];
	entitylist: any [];
	
	
	paymenttermlist: any[];
  //private fieldArray: Array<{id: number, text: string}>;
	public POItemArray: Array<Poitem> = [];
	
    private newAttribute: any = {};
    public POItemChrgArray: Array<Poitem> = [];
    public itemlist = [];
    private newChrgAttribute: any = {};
    poForm: FormGroup;
    public isupdate = false;
    public FormName = "Add a Purchase Order";
 //public type MyArrayType = Array<{id: number, text: string}>;

// const arr: fieldArray = [
//     {id: 1, text: 'Sentence 1'},
//     {id: 2, text: 'Sentence 2'},
//     {id: 3, text: 'Sentence 3'},
// ];

 addFieldValue() {
	 this.newAttribute = {};
	 this.newAttribute.srno = this.POItemArray.length+1;
        this.POItemArray.push(this.newAttribute);
        this.newAttribute = {};
    }

 removeFieldValue() {
	
	if(this.POItemArray.length > 1)
	{
		if(this.POItemArray[this.POItemArray.length-1].poitemid > 0)
		{
			this.deleteditem.push(this.POItemArray[this.POItemArray.length-1].poitemid );
			
		}
		this.POItemArray.pop();
	}
	this.focusOutFunction();
}

addChrgFieldValue() {
  this.newChrgAttribute = {};

       this.POItemChrgArray.push(this.newChrgAttribute);
       this.newChrgAttribute = {};
   }

removeChrgFieldValue() {
 
 if(this.POItemChrgArray.length > 0)
 {
	 
	 if(this.POItemChrgArray[this.POItemChrgArray.length-1].poitemid > 0)
		{
			this.deletedaddtionalitem.push(this.POItemChrgArray[this.POItemChrgArray.length-1].poitemid );
			
		}
	this.POItemChrgArray.pop();
 }
 this.focusOutFunction();
}

//below commented code is for deleting the row added by addItem
/*deleteFieldValue(index) {
        this.fieldArray.splice(index, 1);
    }*/


  constructor(
    private poService: PoService, 
	private costcenterService: CostcenterService,
	private warehouseService: WarehouseService,
	private entityService: EntityService,
    private vendorService : VendorService,
    private location: Location, 
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    public toastr: ToastrManager, 
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
	private userService: UserService,
	private paymenttermservice :PaymenttermService,
  private departmentservice: DepartmentService,
   private spinnerService: Ng4LoadingSpinnerService,
  private itemService: ItemService,
    ) { }

    newPo(): void {
      this.submitted = false;
      this.po = new Po();
	    this.po.podate = new Date(Date.now());
		
    }
	
	
  getPaymentterms() {
    
    return this.paymenttermservice.getPaymentterms()
               .subscribe(
                paymentterms => {              
                  this.paymenttermlist = paymentterms.filter(item => item.active == 1);
                   //console.log(this.paymenttermlist);              
                  
                 }
                );
 }

    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.poForm.invalid) {
          return this.util.showError("Please enter required fields.");		
      }
    else{
      if(this.isupdate){
        this.update();
      }
      else{
        this.addPo();
      }
    }
  }

    addPo() {
      //this.submitted = true;
      this.save();
    }
	
	focusOutFunction()
	{
		this.po.grandtotal = 0;
		this.po.totalvalue =0;
		this.po.totalgst =0;
		if(this.po.currencyid < 2)
		{
			for(var i=0; i<this.POItemArray.length; i++)
			{		
				
			  this.POItemArray[i].totalamount = parseFloat(((this.POItemArray[i].quantity* this.POItemArray[i].unitprice) || 0).toFixed(2));
			  this.POItemArray[i].totalgst = parseFloat(((this.POItemArray[i].totalamount * this.POItemArray[i].itemgst / 100) || 0 ).toFixed(2) );
			  this.POItemArray[i].grandtotal = parseFloat(((this.POItemArray[i].totalamount + this.POItemArray[i].totalgst) || 0).toFixed(2) ) ;
			  this.po.totalvalue += this.POItemArray[i].totalamount;
			  this.po.totalgst += this.POItemArray[i].totalgst;
			}
			
			for(var i=0; i<this.POItemChrgArray.length; i++)
			{				
				if(this.POItemChrgArray[i] != null && this.POItemChrgArray[i].totalamount>0)
				{
					this.POItemChrgArray[i].totalamount = parseFloat(((this.POItemChrgArray[i].totalamount * 1) ||0).toFixed(2));
				this.POItemChrgArray[i].totalgst = parseFloat(((this.POItemChrgArray[i].totalamount * this.POItemChrgArray[i].itemgst / 100) || 0 ).toFixed(2) ) ;
				this.POItemChrgArray[i].grandtotal =parseFloat((( (this.POItemChrgArray[i].totalamount)  + this.POItemChrgArray[i].totalgst ) || 0 ).toFixed(2) ) ;
		  
				//	this.po.grandtotal += Math.floor( this.POItemChrgArray[i].totalamount) || 0;//this.POItemChrgArray[i].;
				this.po.totalvalue +=  (this.POItemChrgArray[i].totalamount || 0);
				this.po.totalgst +=  this.POItemChrgArray[i].totalgst || 0;
				}
			}
				this.po.totalvalue  =  parseFloat(this.po.totalvalue.toFixed(2));
				this.po.totalgst  =  parseFloat(this.po.totalgst.toFixed(2));
				this.po.grandtotal = parseFloat(((this.po.totalvalue + this.po.totalgst) || 0).toFixed(2)); 
		}
		
		else
		{
			for(var i=0; i<this.POItemArray.length; i++)
			{		
				
			  this.POItemArray[i].totalamount = parseFloat(((this.POItemArray[i].quantity* this.POItemArray[i].unitprice) || 0).toFixed(2));
			  this.POItemArray[i].totalgst = 0;
			  this.POItemArray[i].grandtotal = parseFloat((this.POItemArray[i].totalamount).toFixed(2) ) ;
			  this.po.totalvalue += this.POItemArray[i].totalamount;
			 this.po.totalgst += this.POItemArray[i].totalgst;
			}
			
			for(var i=0; i<this.POItemChrgArray.length; i++)
			{				
				if(this.POItemChrgArray[i] != null && this.POItemChrgArray[i].totalamount>0)
				{
					this.POItemChrgArray[i].totalamount = parseFloat(((this.POItemChrgArray[i].totalamount * 1) ||0).toFixed(2));
				this.POItemChrgArray[i].totalgst = 0;//parseFloat(((this.POItemChrgArray[i].totalamount * this.POItemChrgArray[i].itemgst / 100) || 0 ).toFixed(2) ) ;
				this.POItemChrgArray[i].grandtotal =parseFloat((this.POItemChrgArray[i].totalamount).toFixed(2) ) ;
		  
				//	this.po.grandtotal += Math.floor( this.POItemChrgArray[i].totalamount) || 0;//this.POItemChrgArray[i].;
				this.po.totalvalue +=  (this.POItemChrgArray[i].totalamount || 0);
				this.po.totalgst +=  this.POItemChrgArray[i].totalgst || 0;
				}
			}
				this.po.totalvalue  =  parseFloat(this.po.totalvalue.toFixed(2));
				this.po.totalgst  =  parseFloat(this.po.totalgst.toFixed(2));
				this.po.grandtotal = parseFloat(((this.po.totalvalue + this.po.totalgst) || 0).toFixed(2)); 
		}
	}

  // to catch the event
  changeDate(event: any) {
    console.log(event);
  }
   
  private save(): void {
	  this.po.statusid=1;
  //  this.po.paymenttermdays = 30;
    this.po.itemcount = this.POItemArray.length;	  
    this.podata = this.po;

  //var date = new Date(this.po.podate);
  //var newdate = new Date(date);
 // this.podata.podate = newdate.setDate(newdate.getDate() + 1);
    this.spinnerService.show();    
   this.podata.createdby = this.auth.currentUserValue.userid
   
	  this.poService.addPo(this.podata).subscribe((data :any) => {		
		  if(data.poid > 0){
			  
			    this.spinnerService.hide();    
			  for(var i=0; i<this.POItemArray.length; i++)
			  {
				this.POItemArray[i].poid = data.poid;
				this.poService.addPoItem(this.POItemArray[i]).subscribe();
			  }
			  
			  for(var i=0; i<this.POItemChrgArray.length; i++)
			  {
				this.POItemChrgArray[i].isadditionalcharges =1;
				this.POItemChrgArray[i].poid = data.poid;
				this.poService.addPoItem(this.POItemChrgArray[i]).subscribe();
			  }
		
		
				this.poService.GetPODetails(data.poid)
				.subscribe(purchase_order =>
				{
					
						this.purchase_order = purchase_order
						
						if(this.purchase_order != null)
						{
							this.emaildata.userid = this.auth.currentUserValue.userid;
							this.emaildata.subject = "PO No - ED"+ data.poid + " is available for Review.";
							this.emaildata.data ='';
							this.emaildata.userid = this.auth.currentUserValue.userid;
							this.emaildata.subject = "PO No - "+ this.purchase_order.ponumber + " Review Request.";
							this.emaildata.data = "<p>A new PO is "+this.purchase_order.ponumber+" available for your review. Please review the PO <a href='"+webUrL+"' target='_blank'>here</a>: </p>"
							this.emaildata.data += "<div><div>PO no.: "+this.purchase_order.ponumber+"</div><div>PO Name: "+this.purchase_order.description+"</div><div>PO Cost Center: "+this.purchase_order.costcentername+"</div><div>PO Entity: "+this.purchase_order.entityname+"</div><div>PO Location : "+this.purchase_order.warehousename+"</div><div>PO created on :  "+this.purchase_order.podate+"</div><div>PO created by : "+this.purchase_order.createdbyname+"</div><div>Vendor: Vendor Name, Address : "+this.purchase_order.vendorname+" "+this.purchase_order.vendoraddress+"</div></ul></div>";
							this.emaildata.data += "<div>PO Item Details:<table><table class=\"table\" style=\"margin-top:20px;border-collapse: collapse; \" cellPadding=\"10\" border=\"1\"><thead><tr><td>Item Name</td><td>Brand</td><td>Quantity</td><td>UOM</td><td>Unit Price</td><td>GST %</td><td>GST value</td><td>Total Price</td></tr></thead><tbody>";
							for(var i=0; i<this.purchase_order.poitem.length; i++)
							{	if (this.purchase_order.poitem[i].quantity !== null )
								{this.emaildata.data +="<tr><td>"+this.purchase_order.poitem[i].itemdesc+"</td><td>"+this.purchase_order.poitem[i].brandname+"</td><td>"+this.purchase_order.poitem[i].quantity+"</td><td>"+this.purchase_order.poitem[i].uom+"</td><td>"+this.purchase_order.poitem[i].unitprice+"</td><td>"+this.purchase_order.poitem[i].itemgst+"</td><td>"+this.purchase_order.poitem[i].totalgst+"</td><td>"+this.purchase_order.poitem[i].totalamount+"</td></tr>"
							}}
							this.emaildata.data += "</tbody> </table></table><div style=\"margin-top:20px\"><div>Total PO Amount :  "+this.purchase_order.totalvalue+"</div><div style=\"margin-top:20px\">Thanks!</div></div></div>"
						
							this.emaildata.type=1;
							this.emaildata.poid=data.poid;
							this.userService.SendEmail(this.emaildata).subscribe();
								this.util.showSuccess("PO added successfully, PO No :- ED" + data.poid);	
							this.router.navigate(['/po-list']);
						}
				});
		  }
		
		});
		
          //for Redirecting to the list view     
  }
  goBack(): void {
    this.location.back();
  }

  update(): void {
    //this.submitted = true;
    this.submitted = true;
    this.podata = this.po;
    //var date = new Date(this.po.podate);
	//var newdate = new Date(date);
  //this.podata.podate = newdate.setDate(newdate.getDate());
    this.podata.modifiedby = this.auth.currentUserValue.userid;
    this.podata.modifiedon = Date.now();
	  this.spinnerService.show();    
    this.poService.updatePo(this.podata).subscribe((data :any) =>
		{
			  this.spinnerService.hide();    
			  for(var i=0; i<this.POItemArray.length; i++)
			  {
				  if(this.POItemArray[i].poitemid > 0)
				  {
					this.POItemArray[i].poid =  this.po.poid;
					this.poService.updatePoItem(this.POItemArray[i]).subscribe();
				  }
				  else
				  {
					  this.POItemArray[i].poid =  this.po.poid;
						this.poService.addPoItem(this.POItemArray[i]).subscribe();
				  }
			  }
				for(var i =0; i< this.deleteditem.length; i++)
				{
					this.poService.deletePoItem( this.deleteditem[i]).subscribe();
				}
				
			 // For Addtional Charges
			 
			for(var i=0; i<this.POItemChrgArray.length; i++)
			  {
				  if(this.POItemChrgArray[i].poitemid > 0)
				  {
					this.POItemChrgArray[i].poid =  this.po.poid;
					this.POItemChrgArray[i].isadditionalcharges =1;
					this.poService.updatePoItem(this.POItemChrgArray[i]).subscribe();
				  }
				  else
				  {
					  this.POItemChrgArray[i].isadditionalcharges =1;
					  this.POItemChrgArray[i].poid =  this.po.poid;
						this.poService.addPoItem(this.POItemChrgArray[i]).subscribe();
				  }
			  }
				for(var i =0; i< this.deletedaddtionalitem.length; i++)
				{
					this.poService.deletePoItem( this.deletedaddtionalitem[i]).subscribe();
				}
			  
			  
				this.poService.GetPODetails(this.po.poid)
				.subscribe(purchase_order =>
				{
					
						this.purchase_order = purchase_order
						
						if(this.purchase_order != null)
						{
							this.emaildata.userid = this.auth.currentUserValue.userid;
							this.emaildata.subject = "PO No - ED"+ this.po.poid + " is available for Review.";
							this.emaildata.data ='';
							this.emaildata.userid = this.auth.currentUserValue.userid;
							this.emaildata.subject = "PO No - "+ this.purchase_order.ponumber + " Review Request.";
							this.emaildata.data = "<p>A new PO is "+this.purchase_order.ponumber+" available for your review. Please review the PO <a href='"+webUrL+"' target='_blank'>here</a>: </p>"
							this.emaildata.data += "<div><div>PO no.: "+this.purchase_order.ponumber+"</div><div>PO Name: "+this.purchase_order.description+"</div><div>PO Cost Center: "+this.purchase_order.costcentername+"</div><div>PO Entity: "+this.purchase_order.entityname+"</div><div>PO Location : "+this.purchase_order.warehousename+"</div><div>PO created on :  "+this.purchase_order.podate+"</div><div>PO created by : "+this.purchase_order.createdbyname+"</div><div>Vendor: Vendor Name, Address : "+this.purchase_order.vendorname+" "+this.purchase_order.vendoraddress+"</div></ul></div>";
							this.emaildata.data += "<div>PO Item Details:<table><table class=\"table\" style=\"margin-top:20px;border-collapse: collapse; \" cellPadding=\"10\" border=\"1\"><thead><tr><td>Item Name</td><td>Brand</td><td>Quantity</td><td>UOM</td><td>Unit Price</td><td>GST %</td><td>GST value</td><td>Total Price</td></tr></thead><tbody>";
							for(var i=0; i<this.purchase_order.poitem.length; i++)
							{ 	if (this.purchase_order.poitem[i].quantity !== null )
								{this.emaildata.data +="<tr><td>"+this.purchase_order.poitem[i].itemdesc+"</td><td>"+this.purchase_order.poitem[i].brandname+"</td><td>"+this.purchase_order.poitem[i].quantity+"</td><td>"+this.purchase_order.poitem[i].uom+"</td><td>"+this.purchase_order.poitem[i].unitprice+"</td><td>"+this.purchase_order.poitem[i].itemgst+"</td><td>"+this.purchase_order.poitem[i].totalgst+"</td><td>"+this.purchase_order.poitem[i].totalamount+"</td></tr>"
							}
						}
							this.emaildata.data += "</tbody> </table></table><div style=\"margin-top:20px\"><div>Total PO Amount :  "+this.purchase_order.totalvalue+"</div><div style=\"margin-top:20px\">Thanks!</div></div></div>"
						
							this.emaildata.type=1;
							this.emaildata.poid=this.po.poid;
							this.userService.SendEmail(this.emaildata).subscribe();
								this.util.showSuccess("PO Updated successfully, PO No :- ED" + this.po.poid);	
							this.router.navigate(['/po-list']);
						}
				});
			this.util.showSuccess("Purchase Order update successfully.");
			 this.router.navigate(['/po-list']);
		});	
		
       
  }
  
  ngOnInit() {
		// this.po.active = 1;
	  
	  	this.authToken = 'Bearer ' + this.auth.currentUserValue.token;
		
	    this.uploader = new FileUploader({url: URL, authTokenHeader : 'Authorization',authToken: this.authToken ,itemAlias: 'photo'});
	    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
       //overide the onCompleteItem property of the uploader so we are 
       //able to deal with the server response.
       this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
         
            var response = JSON.parse(response);
            var data = {};
			;
            if(response.error_code==0){
				
				if(response.data.length > 0)
				{
					this.po.refdocumentpath = "uploads/" + response.data;
					//this.uploaddata.userid =0;
					
		}}}
	this.newAttribute.srno =1;
	this.deleteditem = new Array();
	this.deletedaddtionalitem = new Array();
	  this.po.podate = new Date(Date.now());
	  this.po.deliverydate =   new Date(Date.now());
	
	this.POItemArray.push(this.newAttribute)
	this.newAttribute = {};
	this.newAttribute.srno =2;
	this.POItemArray.push(this.newAttribute)
	this.newAttribute = {};
    this.newAttribute.srno =3;
	this.POItemArray.push(this.newAttribute)
  
  //this.getItems();
	this.getrequester();
 // this.getdepartment();
	this.getPaymentterms();
	this.getCostcenterlist();
	this.getWarehouseList();
	this.getCurrencyList();
	this.getEntityList();
	this.getVendors();
    if(this.route.snapshot.paramMap.get('po_id') != null)
    {
      const po_id = +this.route.snapshot.paramMap.get('po_id');
       if(po_id > 0)
       {
		  this.getItems();
         this.getPo(po_id);
       }
       this.isupdate = true;
       this.FormName = "Update Purchase Order";				 
    }
    this.poForm = this.formBuilder.group({			
     
      podate: [this.po.podate,[Validators.required, Validators.required]],
      requesterid: [this.po.requesterid,[Validators.required, Validators.required]],
      departmentid: [this.po.departmentid,[Validators.required, Validators.required]],
      vendorid: [this.po.vendorid,[Validators.required, Validators.required,Validators.required]],
      notetovendor: [this.po.notetovendor,[Validators.required, Validators.required]],
	   paymenttermid: [this.po.paymenttermid,[Validators.required, Validators.required]],
	    currencyid: [this.po.currencyid,[Validators.required, Validators.required]],
	    costcenterid: [this.po.costcenterid,[Validators.required, Validators.required]],
	    entityid: [this.po.entityid,[Validators.required, Validators.required]],
		warehouseid: [this.po.warehouseid,[Validators.required, Validators.required]],
	   gstno: [this.po.gstno,[Validators.required, Validators.required]],
	 deliverydate: [this.po.deliverydate,[Validators.required, Validators.required]],
	 remarks: [this.po.remarks],
	 penaltyclause: [this.po.penaltyclause],
	 refdocumentpath: [this.po.refdocumentpath],
	
			description: [this.po.description,[Validators.required, Validators.required]],
			// active: [this.po.active,[Validators.required, Validators.required]]
	  
    });	
    
  //   this.dateOptions = ({
  //     maxDate: new Date(Date.now()),
  //     minDate: new Date(Date.now())
  // });
  
  }
  // convenience getter for easy access to form fields
get f() {
  return this.poForm.controls
  }

  getVendors() {
    return this.vendorService.getVendorlist()
               .subscribe(
                vendors => {
               
                  this.vendors = vendors.filter(item => item.active == 1) ;
				  
                 }
                );
 }
 

 
   
  public onVendorChangeObj(objvendorid){
		this.selectedvendor = this.vendors.filter(items => items.vendorid == objvendorid);	
		if(this.selectedvendor !=null)
		{
			this.po.gstno =this.selectedvendor[0].gstno;
			this.po.hsncode = this.selectedvendor[0].hsncode;
		}
  }
  
  public onitemChangeObj(itemid,itemIndex){
    var selecteditem = this.itemlist.filter(items => items.itemid == itemid);	
   	if(selecteditem !=null)
		{
		this.POItemArray[itemIndex].itemgst =selecteditem[0].gst;
		this.POItemArray[itemIndex].brandname = selecteditem[0].brandname;
		
      console.log("---"+this.POItemArray[itemIndex].itemgst)
    }
    this.focusOutFunction();
  }

	  public onRequestorChangeObj(objrequestorId){
		
		 return this.departmentservice.GetDepartmentByHead(objrequestorId)
               .subscribe(
                dept => {  

				   if (!Array.isArray(dept)) {
	                    this.department.push(dept);

	                }
	                else {
	                    this.department = dept;
	                }
                //  this.department = dept;
				  if(this.department != null && this.department.length < 2)
				  {
					  this.po.departmentid =this.department[0].deptid;
				  }
                 }
                );
	}
 
    getrequester() {
    return this.poService.getrequester()
               .subscribe(
                requester => {                  
                  this.requester = requester				  
                 }
                );
 }
 onInputChangedEvent(val: any) {
  if(val.term.length > 0 ){
    this.getItems()
  }
  this.itemlist = [];
}
 
 getItems() {
  return this.itemService.getItems()
             .subscribe(
              items => {
                console.log(items);
                this.itemlist = items
               }
              );
	}
	
  getCurrencyList() {
		  return this.poService.getCurrency()
					 .subscribe(
					  currency => {
					
						this.currencylist = currency
					   }
					  );
	}
	
  getCostcenterlist() {
		  return this.costcenterService.getCostcenterlist()
					 .subscribe(
					  costcenter => {
					   
						this.costcenterlist = costcenter.filter(item => item.active == 1);
					   }
					  );
	}
	
	 getEntityList() {
			  return this.entityService.getEntitylist()
						 .subscribe(
						  entity => {						
							this.entitylist = entity.filter(item => item.active == 1);
						   }
						  );
	}
	
	 getWarehouseList() {
			  return this.warehouseService.getWarehouse()
						 .subscribe(
						  warehouse => {              
							this.warehouselist = warehouse.filter(item => item.active == 1);
						   }
						  );
		}

 getPo(poid) {
  return this.poService.GetPODetails(poid)
             .subscribe(
              po => {              
                this.po = po   
				if(this.po != null)
				{
						this.po.gstno =this.po.egstin;
					this.onRequestorChangeObj(this.po.requesterid);
					this.POItemArray = this.po.poitem.filter(items => items.isadditionalcharges == 0);
					this.POItemChrgArray = this.po.poitem.filter(items => items.isadditionalcharges == 1);					
						
				
								//this.po.hsncode = this.selectedvendor[0].hsncode;
							
						
				}
               }
              );
}

//below function is to restrict special character in input field
omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

}
